import React from 'react'
import { H2 } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'

export const NoItems = ({ title, marginTop, smallText }: { title: string, marginTop?: string, smallText?: boolean }) => {
  return (
    <>
      {smallText ? <BodyText weight='bold' style={{ marginTop }} >No {title} to display</BodyText> : <H2 style={{ marginTop }} >No {title} to display</H2>}
    </>
  )
}
